import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";
import { Colors } from "@remo-co/ui-core/theme";

export const useStyles = makeStyles<Theme>((theme) => ({
  systemCheckContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      maxWidth: "100%",
    },
    "& .warning": {
      color: "#ffa500",
      marginRight: "10px",
    },
    "& .success": {
      color: "#00c4b5",
      marginRight: "10px",
    },
    "& .error": {
      color: "#dc3545",
      marginRight: "10px",
    },
    "& .body": {
      padding: "45px",
      width: "400px",
      borderRadius: "10px",
      backgroundColor: Colors.WHITE,
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        padding: "1rem",
        boxSizing: "border-box",
      },
      "& .text": {
        textAlign: "center",
        padding: "30px 0px 20px 0px",
      },
      "& .failedText": {
        textAlign: "center",
        padding: "30px 0px 20px 0px",
        "& span": {
          color: "#dc3545",
        },
      },
      "& .successText": {
        padding: "30px 0px 20px 0px",
        textAlign: "center",
        fontWeight: 500,
      },
      "& .buttonText": {
        color: Colors.WHITE,
      },
      "& .link": {
        textAlign: "center",
      },
    },
  },
}));
